import React from "react";
import RangeInput from "../items/RangeInput";
import ToggleContainer from "../items/ToggleSwitch";
import Icon from "../../../common/components/Icon";
import { t } from "i18next";

function LeftSections({
    openCategoryModal,
    selectedCategory,
    resetFilters,
    minPrice,
    maxPrice,
    onPriceChange,
    isContract,
    onContractToggle,
}) {
    return (
        <div className="hidden md:flex flex-col gap-4 bg-white rounded-xl p-5 w-[280px] shrink-0 sticky top-[80px] h-fit">
            {/* Header */}
            <div className="flex items-end justify-between">
                <h2 className="m-0 text-[20px] font-bold text-[#222222]">{t('filters')}</h2>
                <button
                    className="text-[13px] font-medium text-[#939393] hover:text-[#147F26] transition-colors bg-transparent border-none cursor-pointer p-0"
                    onClick={resetFilters}
                >
                    {t('reset')}
                </button>
            </div>

            {/* Category selector */}
            <div className="flex flex-col gap-2">
                <h3 className="m-0 text-[14px] font-semibold text-[#222222]">{t('selectCategory')}</h3>
                <button
                    className="flex items-center justify-between gap-2 w-full border border-[#147F26] rounded-xl px-4 py-2.5 text-[13px] text-[#222222] bg-transparent hover:bg-[#147F26]/5 transition-colors cursor-pointer overflow-hidden"
                    onClick={openCategoryModal}
                >
                    <span className="flex-1 text-left overflow-hidden text-ellipsis whitespace-nowrap">
                        {selectedCategory || t('selectCategory')}
                    </span>
                    <Icon src="right_arrow" alt="right" />
                </button>
            </div>

            <hr className="border-[#EDEDED] m-0" />

            {/* Price range */}
            <div className="flex flex-col gap-3">
                <h3 className="m-0 text-[14px] font-semibold text-[#222222]">{t('price')}</h3>
                <RangeInput
                    minValue={minPrice}
                    maxValue={maxPrice}
                    onMinChange={(min) => onPriceChange(min, maxPrice)}
                    onMaxChange={(max) => onPriceChange(minPrice, max)}
                />
            </div>

            {/* Negotiable toggle */}
            <ToggleContainer
                isContract={isContract}
                onContractToggle={onContractToggle}
            />
        </div>
    );
}

export default LeftSections;
